module.exports = __webpack_public_path__ + "static/media/5.20_preview.23ea986a.png";